import { gql } from 'graphql-tag'

import {
  FRAGMENT_CONVERSATION_SINGLE_CONVERSATION,
  FRAGMENT_CONVERSATION_SINGLE_MESSAGE,
} from '../ConversationSingle.hasura'

const REALTIME_CONVERSATION_MESSAGE = gql`
  fragment RealtimeConversationMessage on message {
    id
    ...ConversationSingleMessage
  }
  ${FRAGMENT_CONVERSATION_SINGLE_MESSAGE}
`

export const REALTIME_CONVERSATION_SUBSCRIPTION = gql`
  subscription RealtimeConversationSingle(
    $currentUserId: Int!,
    $limitMessagesOld: Int,
    $whereConversation: conversation_bool_exp!,
    $whereMessagesOld: message_bool_exp!,
    $whereMessagesNew: message_bool_exp!,
  ) {
    conversation(limit: 1, where: $whereConversation) {
      ...ConversationSingleConversation
      messagesOld: messages(limit: $limitMessagesOld, order_by: { created_at: desc }, where: $whereMessagesOld) {
        ...RealtimeConversationMessage
      }
      messagesNew: messages(order_by: { created_at: desc }, where: $whereMessagesNew) {
        ...RealtimeConversationMessage
      }
    }
  }
  ${FRAGMENT_CONVERSATION_SINGLE_CONVERSATION}
  ${REALTIME_CONVERSATION_MESSAGE}
`
